import useSWRImmutable from 'swr/immutable';

import { ComponentQuery } from 'models';

import { ComponentService } from 'services/ComponentService';

const useProductSearchCount = (query: Partial<ComponentQuery>) => {
    const swr = useSWRImmutable(['/components/search/count', query], async () => {
        const { totalResults } = await ComponentService.search({ ...query, limit: 1 });

        return (totalResults as number | undefined) ?? 0;
    });

    return {
        ...swr,
        count: swr.data ?? 0,
    };
};

export { useProductSearchCount };
